
export const getToken = () => {
  let token = new URLSearchParams(window.location.search).get('token');
  if (!token) {
    const containerEl = window.document.getElementById(process.env.REACT_APP_ELEMENT_ID || 'advice-robo-pcs');
    token = containerEl ? containerEl.getAttribute('data-token') : null;
  }

  return token;
};